

<div id="email-page-container" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%"  style="padding: 10px;">
    <mat-card-content>
      <mat-card-title>
        {{titleText }}
      </mat-card-title>
      <form [formGroup]="loginForm" (ngSubmit)="submitFun()" *ngIf="!showEmailList && !redirectMismatch">
        <mat-card-content>
          <mat-error *ngIf="(error.error === true)">{{error.msg}} </mat-error>
          <P class="success" *ngIf="(error.success === true)">{{error.msg}}</P>
          <mat-form-field fxFlex="100%" appearance="fill" >
            <label>{{emailText }}</label>
            <input matInput formControlName="email">
            <mat-error *ngIf="errorHandling('email', 'required') || errorHandling('email', 'email')">
              {{emailError }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="showIDPList">
          <mat-form-field >
            <label>Select Identity Provider</label>
            <mat-select formControlName="selectedIDP">
              <mat-option *ngFor="let IDP of IDPList" [value]="IDP['providerName']"
                (click)="setIdpValue(IDP['providerName'])">
                {{IDP['providerName']}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error *ngIf="errorHandling('selectedIDP', 'required') || errorHandling('selectedIDP', 'email')">
            {{'Please select an Identity provider'}}
          </mat-error>
          </ng-container>
        </mat-card-content>
        <mat-card-actions class="right center-align">
          <button [hidden]="loadSpinner" mat-flat-button class="btn" [disabled]="disableSubmitBtn">{{ buttonText }}</button>
           <button *ngIf="loadSpinner" mat-flat-button class="btn" >
            Loading..
            <span>
              <mat-progress-spinner style="float: right; margin-top: 2px; margin-left: 8px;" color="primary"
                mode="indeterminate" [diameter]="18" title="Loading.....">
              </mat-progress-spinner>
            </span>
          </button>
         </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<app-cookie-consent *ngIf="showCookieNotification"></app-cookie-consent>
